import React from "react";
import { useTranslation } from "react-i18next";
import "../Styles/PreferredLanguageCard.scss";

interface PreferredLanguageCardProps {
  preferredNotificationLanguage: "en" | "ar";
  savingLanguage: boolean;
  onLanguageChange: (_language: "en" | "ar") => void;
}

const PreferredLanguageCard: React.FC<PreferredLanguageCardProps> = ({
  preferredNotificationLanguage,
  savingLanguage,
  onLanguageChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="preferred-language-card">
      <div className="preferred-language-info">
        <span className="preferred-language-title">
          {t("notificationPreferences.preferredLanguage.title", {
            defaultValue: "Preferred Language",
          })}
        </span>
        <span className="preferred-language-subtitle">
          {t("notificationPreferences.preferredLanguage.description", {
            defaultValue: "Select your preferred language for receiving notifications.",
          })}
        </span>
      </div>
      <div
        className="preferred-language-segmented"
        role="group"
        aria-label={t("notificationPreferences.preferredLanguage.title", {
          defaultValue: "Preferred Language",
        })}
      >
        {(["en", "ar"] as const).map(lang => (
          <button
            key={lang}
            type="button"
            className={`preferred-language-segmented-button${
              preferredNotificationLanguage === lang
                ? " preferred-language-segmented-button--active"
                : ""
            }`}
            aria-pressed={preferredNotificationLanguage === lang}
            disabled={savingLanguage}
            onClick={() => onLanguageChange(lang)}
          >
            {t(`notificationPreferences.preferredLanguage.options.${lang}`, {
              defaultValue: lang === "en" ? "English" : "Arabic",
            })}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PreferredLanguageCard;
